import { useState } from 'react';
import AccordionItemHandler from 'components/forms/new/AccordionItemHandler';
import CompanyName from '../formFields/CompanyName';
import LegalEntityName from '../formFields/LegalEntityName';
import DefaultAddress from '../formFields/DefaultAddress';
import BusinessNumber from '../formFields/BusinessNumber';
import InitialDomain from '../formFields/InitialDomain';
import useGetAddresses from '@/queries/company/useGetAddresses';
import { useCompanyForm } from '../../hooks/useCompanyForm';

const CompanyGeneralCompany = ({ errors, touched, darkMode, isAddMode }) => {
    const [addresses, setAddresses] = useState([]);
    const { formData } = useCompanyForm();
    const { isFetching: isFetchingAddresses } = useGetAddresses(
        formData?.id,
        setAddresses,
    );

    const formFields = (errors, touched) => {
        const fields = [
            // Company Name - Always show
            <CompanyName
                key="companyName"
                errors={errors}
                touched={touched}
                darkMode={darkMode}
                isAddMode={isAddMode}
            />,
            <LegalEntityName
                key="legalEntityName"
                errors={errors}
                touched={touched}
                darkMode={darkMode}
            />,
            <InitialDomain
                key="initialDomain"
                darkMode={darkMode}
                errors={errors}
                touched={touched}
            />,
            <DefaultAddress
                key="defaultAddress"
                addresses={addresses}
                errors={errors}
                darkMode={darkMode}
                isFetchingAddresses={isFetchingAddresses}
            />,
            <BusinessNumber
                key="businessNumber"
                errors={errors}
                touched={touched}
                darkMode={darkMode}
            />,
        ];

        return fields;
    };

    const filteredFields = formFields(errors, touched).filter(Boolean);

    return (
        <AccordionItemHandler
            index={0}
            key="companyGeneral"
            label="Company Details"
            errors={errors}
            touched={touched}
            defaultIsOpen={true}>
            {filteredFields}
        </AccordionItemHandler>
    );
};

export default CompanyGeneralCompany;
